import React from 'react'
import ReactDOM from 'react-dom'

import { LoadingSpinner } from '../components'
import { lti as endpoints } from '../api_urls'
import { client, convertStringBool } from '../utils'

import ContentItemSelection from './components/ContentItemSelection'
import ContentItemSelectionError from './components/ContentItemSelectionError'

export const startContentItemSelectionApp = (coursenum, acceptMultipleStr) => {
  ReactDOM.render(
    <div className="text-center lead">
      <LoadingSpinner text="Getting Content Items..." className="icon_3x" />
    </div>,
    document.getElementById('content-item-selection-app')
  )
  getGroupData()
    .then(gdObj => {
      const acceptMultiple = convertStringBool(acceptMultipleStr)
      ReactDOM.render(
        <ContentItemSelection
          acceptMultiple={acceptMultiple}
          groups={gdObj.data.groups}
          chapters={gdObj.data.chapters}
          coursenum={coursenum}
          handleSubmit={postGroupData}
        />,
        document.getElementById('content-item-selection-app')
      )
    })
    .catch(error => {
      ReactDOM.render(
        <ContentItemSelectionError error={error} />,
        document.getElementById('content-item-selection-app')
      )
    })
}

function getGroupData() {
  const url = endpoints.getItemGroups()
  return client.get(url)
}

async function postGroupData(selectData) {
  try {
    const url = endpoints.postItemGroups()
    const response = await client.post(url, selectData)
    for (let field in response.data) {
      document.getElementsByName(field)[0].value = response.data[field]
    }
    document.getElementById('content-item-selection').submit()
  } catch (err) {
    $.meDialog.topMessage(
      '<p>An error occurred. Please contact MyEducator support if the issue persists.</p>',
      3000,
      'danger'
    )
  }
}
